import { useStore } from "vuex";

export default function useEntryData() {
  const store = useStore();

  async function loadEntryData({ categoryID, entryID }) {
    await store.dispatch("api/fetchCategory", { id: categoryID });

    const category = store.getters["api/category"](categoryID);

    await store.dispatch(
      "setPageData",
      { pageName: "Category", data: category },
      { root: true }
    );

    const entry = store.getters["api/entry"](categoryID, entryID);

    await store.dispatch(
      "setPageData",
      { pageName: "Person", data: entry },
      { root: true }
    );
  }

  return {
    loadEntryData,
  };
}
